import {TFunction} from 'i18next';
import {RowData} from '../../base/export-care-plan-group-data-processor';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class EscortPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (rowData: RowData) => {
      // TODO: We should get by feature.
      const escortEntry = rowData.getEntryById('64ed423f3e401e83ae6fadc4');
      const escortName = `<b>${escortEntry?.name ?? 'n/a'}:</b>`;
      const escortValue = this.getEntryValue(escortEntry);

      return `${escortName}\n${escortValue}`;
    };
  }
}
